import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./SignIn.css";

const SignIn = ({ setIsAuthenticated }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const [signInDetails, setSignInDetails] = useState({
    email: '',
    password: '',
  });

  const handleOnChange = (e) => {
    setSignInDetails({
      ...signInDetails,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (signInDetails.email === '' || signInDetails.password === '') {
      setError('Please fill in all the required fields');
      return;
    }

    setLoading(true);
    try {
      // Simulate API request (replace with actual authentication logic)
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Store user session in localStorage
      localStorage.setItem('userDetails', JSON.stringify({
        email: signInDetails.email,
        name: signInDetails.email.split('@')[0] // Extract name from email
      }));

      // ✅ Update auth state immediately - no page reload needed!
      if (setIsAuthenticated) {
        setIsAuthenticated(true);
      }

      // Show popup notification
      setShowPopup(true);

      // Redirect to home page after a brief delay
      setTimeout(() => {
        navigate("/");
      }, 1500);

    } catch (err) {
      setError('Sign in failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-in-container">
      {showPopup && (
        <div className="popup-notification success">
          <i className="fas fa-check-circle"></i>
          <p>User successfully signed in 😃</p>
        </div>
      )}

      <div className="sign-in-card">
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            Error: {error}
          </div>
        )}

        <h2 className="sign-in-title">
          <i className="fas fa-sign-in-alt"></i>
          Sign in
        </h2>

        <form onSubmit={handleSubmit} className="sign-in-form">
          <div className="input-group">
            <label htmlFor="email">
              <i className="fas fa-envelope"></i>
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={signInDetails.email}
              onChange={handleOnChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={signInDetails.password}
              onChange={handleOnChange}
              placeholder="Enter your password"
              required
            />
          </div>

          <Link to="/forgot-password" className="forgot-password">
            Forgot password?
          </Link>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Signing in...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Sign in
              </>
            )}
          </button>

          <p className="switch-auth">
            Don't have an account?{' '}
            <Link to="/sign-up" className="auth-link">
              Sign up
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
